import React, { useState } from "react";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
  <header className="bg-sky-950   max-w-7xl mx-auto shadow-md relative top-2 left-0 right-0 z-50 rounded-md">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        {/* Logo & Brand below */}
        <a href="/" className="flex flex-col items-center">
          <img
            src="/logo.jpg"
            alt="Circuitcy Logo"
            className="h-12 w-24 rounded-md"
          />
          <span className="text-lg font-bold text-white  ">
            Circuitcy
          </span>
          <span className="text-lg -mt-3 -mb-2 font-bold text-white ">
           Technology
          </span>
        </a>

        {/* Hamburger for mobile */}
        <button
          className="md:hidden text-sky-700 focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {isOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>

        {/* Nav Links */}
        <nav
          className={`${
            isOpen ? "block" : "hidden"
          } absolute md:static top-full left-0 w-full md:w-auto bg-sky-950 md:bg-transparent shadow-md md:shadow-none md:flex items-center flex-col md:flex-row gap-6 p-6 md:p-0 text-lg font-medium text-white  transition-all duration-300`}
        >
          <div className="mr-8 space-x-8">
          <a href="#about" className="hover:text-yellow-500 transition duration-200">
            About
          </a>
          <a href="#services" className="hover:text-yellow-500 transition duration-200">
            Internships
          </a>
          <a
            href="https://forms.gle/zfFzGDwAKVhL7cDd9"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-yellow-500 transition duration-200"
          >
            Apply
          </a>
          <a href="#contact" className="hover:text-yellow-500 transition duration-200">
            Contact
          </a>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
